import { axios } from '@/utils/request'

const api = {
    goodsOptions: '/badminapi/goods/goodsOptions',
    cateTreeList: '/badminapi/goods/cateTreeList',
    cateList: '/badminapi/goods/cateList',
    cateAdd: '/badminapi/goods/cateAdd',
    cateEdit: '/badminapi/goods/cateEdit',
    cateDelete: '/badminapi/goods/cateDelete',
    cateDetail: '/badminapi/goods/cateDetail',
    setCateRank: '/badminapi/goods/setCateRank',
    fieldList: '/badminapi/goods/fieldList',
    attrList: '/badminapi/goods/attrList',
    skuFieldAdd: '/badminapi/goods/skuFieldAdd',
    skuFieldEdit: '/badminapi/goods/skuFieldEdit',
    skuAttrAdd: '/badminapi/goods/skuAttrAdd',
    skuAttrEdit: '/badminapi/goods/skuAttrEdit',
    skuAttrDelete: '/badminapi/goods/skuAttrDelete',
    skuFieldDelete: '/badminapi/goods/skuFieldDelete',
    skuDetail: '/badminapi/goods/skuDetail',
    stockSetInc: '/badminapi/goods/stockSetInc',
    skuEdit: '/badminapi/goods/skuEdit',
    goodsEdit: '/badminapi/goods/goodsEdit',
    goodsAdd: '/badminapi/goods/goodsAdd',
    goodsContentEdit: '/badminapi/goods/goodsContentEdit',
    goodsDetail: '/badminapi/goods/goodsDetail',
    goodsList: '/badminapi/goods/goodsList',
    setGoodsStatus: '/badminapi/goods/setGoodsStatus',
    setGoodsAllStatus: '/badminapi/goods/setGoodsAllStatus',
    goodsDelete: '/badminapi/goods/goodsDelete',
    deleteGoodsAll: '/badminapi/goods/goodsDeleteAll',
    goodsRankEdit: '/badminapi/goods/goodsRankEdit',
    getSellerRewardSetting: '/badminapi/goods/getSellerRewardSetting',
    getPartnerCashSetting: '/badminapi/goods/getPartnerCashSetting',
    sellerRewardSetting: '/badminapi/goods/sellerRewardSetting',
    partnerCashSetting: '/badminapi/goods/partnerCashSetting',
    getDealtownRewardSetting: '/badminapi/goods/getDealtownRewardSetting',
    dealtownRewardSetting: '/badminapi/goods/dealtownRewardSetting',
    getBaseOptions: '/badminapi/businessbase/baseOptions',
    onHandleRecom: '/badminapi/goods/onHandleRecom',
    NotHandleRecom: '/badminapi/goods/NotHandleRecom',
    getCateMemberDiscountSetting: '/badminapi/goods/getCateMemberDiscountSetting',
    getMemberDiscountSetting: '/badminapi/goods/getMemberDiscountSetting',
    memberDiscountSetting: '/badminapi/goods/memberDiscountSetting',
    cateMemberDiscountSetting: '/badminapi/goods/cateMemberDiscountSetting',

    getGoodsDownloadUrl: '/badminapi/goods/getGoodsDownloadUrl',
    getGoodsStockDownloadUrl: '/badminapi/goods/getGoodsStockDownloadUrl',
    getGoodsRewardSetting: '/badminapi/goods/getGoodsRewardSetting',
    goodsRewardSetting: '/badminapi/goods/goodsRewardSetting',

    setStockWarningCount: '/badminapi/goods/setStockWarningCount',

    getGoodsSkuList: '/badminapi/goods/getGoodsSkuList',
    goodsSkuDownUrl: '/badminapi/goods/goodsSkuDownUrl',

}

export default api

export function goodsSkuDownUrl(parameter) {
    return axios({
        url: api.goodsSkuDownUrl,
        method: 'get',
        params: parameter
    })
}

export function getGoodsSkuList(parameter) {
    return axios({
        url: api.getGoodsSkuList,
        method: 'get',
        params: parameter
    })
}
export function setStockWarningCount(parameter) {
    return axios({
        url: api.setStockWarningCount,
        method: 'post',
        data: parameter
    })
}

export function goodsRewardSetting(parameter) {
    return axios({
        url: api.goodsRewardSetting,
        method: 'post',
        data: parameter
    })
}

export function getGoodsRewardSetting(parameter) {
    return axios({
        url: api.getGoodsRewardSetting,
        method: 'get',
        params: parameter
    })
}

export function getGoodsDownloadUrl(parameter) {
    return axios({
        url: api.getGoodsDownloadUrl,
        method: 'post',
        data: parameter
    })
}


export function getGoodsStockDownloadUrl(parameter) {
    return axios({
        url: api.getGoodsStockDownloadUrl,
        method: 'post',
        data: parameter
    })
}

export function getGoodsList(parameter) {
    return axios({
        url: api.goodsList,
        method: 'get',
        params: parameter
    })
}

export function getGoodsOptions(parameter) {
    return axios({
        url: api.goodsOptions,
        method: 'get',
        params: parameter
    })
}

export function getGoodsDetail(parameter) {
    return axios({
        url: api.goodsDetail,
        method: 'get',
        params: parameter
    })
}

export function getCateTreeList(parameter) {
    return axios({
        url: api.cateTreeList,
        method: 'get',
        params: parameter
    })
}

export function getCateList(parameter) {
    return axios({
        url: api.cateList,
        method: 'get',
        params: parameter
    })
}

export function addGoods(parameter) {
    return axios({
        url: api.goodsAdd,
        method: 'post',
        data: parameter
    })
}

export function editGoods(parameter) {
    return axios({
        url: api.goodsEdit,
        method: 'post',
        data: parameter
    })
}

export function addCate(parameter) {
    return axios({
        url: api.cateAdd,
        method: 'post',
        data: parameter
    })
}

export function setCateRank(parameter) {
    return axios({
        url: api.setCateRank,
        method: 'post',
        data: parameter
    })
}

export function editCate(parameter) {
    return axios({
        url: api.cateEdit,
        method: 'post',
        data: parameter
    })
}

export function deleteCate(parameter) {
    return axios({
        url: api.cateDelete,
        method: 'post',
        data: parameter
    })
}

export function getCateDetail(parameter) {
    return axios({
        url: api.cateDetail,
        method: 'get',
        params: parameter
    })
}

export function getAttrList(parameter) {
    return axios({
        url: api.attrList,
        method: 'get',
        params: parameter
    })
}

export function getFieldList(parameter) {
    return axios({
        url: api.fieldList,
        method: 'get',
        params: parameter
    })
}

export function skuFieldAdd(parameter) {
    return axios({
        url: api.skuFieldAdd,
        method: 'post',
        data: parameter
    })
}

export function skuFieldEdit(parameter) {
    return axios({
        url: api.skuFieldEdit,
        method: 'post',
        data: parameter
    })
}

export function skuAttrAdd(parameter) {
    return axios({
        url: api.skuAttrAdd,
        method: 'post',
        data: parameter
    })
}

export function skuAttrEdit(parameter) {
    return axios({
        url: api.skuAttrEdit,
        method: 'post',
        data: parameter
    })
}

export function skuAttrDelete(parameter) {
    return axios({
        url: api.skuAttrDelete,
        method: 'post',
        data: parameter
    })
}

export function skuFieldDelete(parameter) {
    return axios({
        url: api.skuFieldDelete,
        method: 'post',
        data: parameter
    })
}


export function skuDetail(parameter) {
    return axios({
        url: api.skuDetail,
        method: 'get',
        params: parameter
    })
}

export function stockSetInc(parameter) {
    return axios({
        url: api.stockSetInc,
        method: 'post',
        data: parameter
    })
}

export function skuEdit(parameter) {
    return axios({
        url: api.skuEdit,
        method: 'post',
        data: parameter
    })
}

export function goodsContentEdit(parameter) {
    return axios({
        url: api.goodsContentEdit,
        method: 'post',
        data: parameter
    })
}

export function setGoodsAllStatus(parameter) {
    return axios({
        url: api.setGoodsAllStatus,
        method: 'post',
        data: parameter
    })
}

export function setGoodsStatus(parameter) {
    return axios({
        url: api.setGoodsStatus,
        method: 'post',
        data: parameter
    })
}

export function deleteGoods(parameter) {
    return axios({
        url: api.goodsDelete,
        method: 'post',
        data: parameter
    })
}

export function deleteGoodsAll(parameter) {
    return axios({
        url: api.deleteGoodsAll,
        method: 'post',
        data: parameter
    })
}

export function setGoodsRank(parameter) {
    return axios({
        url: api.goodsRankEdit,
        method: 'post',
        data: parameter
    })
}


export function sellerRewardSetting(parameter) {
    return axios({
        url: api.sellerRewardSetting,
        method: 'post',
        data: parameter
    })
}
export function partnerCashSetting(parameter) {
    return axios({
        url: api.partnerCashSetting,
        method: 'post',
        data: parameter
    })
}

export function getSellerRewardSetting(parameter) {
    return axios({
        url: api.getSellerRewardSetting,
        method: 'get',
        params: parameter
    })
}

export function getPartnerCashSetting(parameter) {
    return axios({
        url: api.getPartnerCashSetting,
        method: 'get',
        params: parameter
    })
}

export function dealtownRewardSetting(parameter) {
    return axios({
        url: api.dealtownRewardSetting,
        method: 'post',
        data: parameter
    })
}

export function cateMemberDiscountSetting(parameter) {
    return axios({
        url: api.cateMemberDiscountSetting,
        method: 'post',
        data: parameter
    })
}

export function memberDiscountSetting(parameter) {
    return axios({
        url: api.memberDiscountSetting,
        method: 'post',
        data: parameter
    })
}

export function getDealtownRewardSetting(parameter) {
    return axios({
        url: api.getDealtownRewardSetting,
        method: 'get',
        params: parameter
    })
}

export function getCateMemberDiscountSetting(parameter) {
    return axios({
        url: api.getCateMemberDiscountSetting,
        method: 'get',
        params: parameter
    })
}

export function getMemberDiscountSetting(parameter) {
    return axios({
        url: api.getMemberDiscountSetting,
        method: 'get',
        params: parameter
    })
}

export function getBaseOptions(parameter) {
    return axios({
        url: api.getBaseOptions,
        method: 'get',
        params: parameter
    })
}

export function onHandleRecom(parameter) {
    return axios({
        url: api.onHandleRecom,
        method: 'post',
        params: parameter
    })
}

export function NotHandleRecom(parameter) {
    return axios({
        url: api.NotHandleRecom,
        method: 'post',
        params: parameter
    })
}